import React, { useState, useContext, useCallback, useEffect } from "react";

import {
  Dimensions,
  ActivityIndicator,
  View,
  Text,
  ScrollView,
  TouchableWithoutFeedback,
} from "react-native";

import Icon from "react-native-vector-icons/Feather";
import palette from "~/styles/palette";
import Avatar from "~/components/Avatar/index";
import AnimatedLogo from "~/components/Logo/AnimatedLogo";

import Col from "~/layouts/Col";
import Row from "~/layouts/Row";

import Heading from "~/components/Heading/";
import TeamContext from "~/contexts/TeamContext";
import NumberContext from "~/contexts/NumberContext";
import SolidButton from "~/components/Buttons/SolidButton/";

import Engage from "~/services/engage";

export default function AssignmentModal({ onBackPress }) {
  const {
    saving,
    loading,
    number,
    dirty,
    error,
    fullNumber,
    saveNumber,
    updateNumber,
  } = useContext(NumberContext);

  const setAssignments = (a) => updateNumber({ assigned: a });

  const onAssignmentHandler = useCallback(
    (user) => () => {
      let copy = number.assignees.concat();
      // const removed = copy.filter((a) => user.id !== a.user_id);

      if (!copy.find((u) => u.id === user.id)) {
        copy = copy.concat({
          user,
          user_id: user.id,
        });

        Engage.assignNumber({ id: number.id, user_id: user.id }).then((res) => {
          console.log("onAssign", JSON.stringify(res, null, 2));
        });
      } else {
        copy = copy.filter((a) => user.id !== a.user_id);

        Engage.revokeNumberAccess({ id: number.id, user_id: user.id }).then(
          (res) => {
            // console.log('onRevoke', JSON.stringify(res, null, 2));
          }
        );
      }

      saveNumber().then((res) => console.log("update assignment", res));
      // setAssignments(copy);
    },
    [number.assignees, setAssignments, number.id]
  );

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <Row pl={16} mt={32} height="100%" center>
        <SolidButton icon="x" mr={16} onPress={onBackPress} label="Close" />

        <Heading size={1}>Assign Number</Heading>

        {loading ? (
          <Col leftCenter pl={16}>
            <ActivityIndicator size="small" />
          </Col>
        ) : (
          <Col />
        )}
      </Row>

      <Row pl={16} pr={16} pt={8} left>
        <TeamList assigned={number.assignees} onPress={onAssignmentHandler} />
      </Row>
    </View>
  );
}

const TeamList = ({ assigned, onPress }) => {
  const { users, getUsers } = useContext(TeamContext);

  useEffect(() => {
    getUsers();
  }, []);

  if (users.length < 1) {
    return null;
  }

  return (
    <ScrollView style={{ flex: 1 }}>
      <View>
        {users.map((user, x) => {
          const isActive = assigned?.find((active) => active.id === user.id);

          return (
            <View key={x}>
              <UserItem
                key={x}
                user={user}
                active={isActive}
                onPress={onPress(user)}
              />
            </View>
          );
        })}
      </View>
    </ScrollView>
  );
};

const TeamLabel = ({ title }) => {
  return (
    <View
      style={{
        paddingHorizontal: 15,
        paddingVertical: 10,
        backgroundColor: palette.lightest_grey,
      }}
    >
      <Text style={{ fontWeight: "500" }}>{title}</Text>
    </View>
  );
};

const UserItem = ({ user, active = false, onPress }) => {
  const { first_name, last_name } = user;

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View
        style={{
          width: "100%",
          paddingHorizontal: 10,
          borderBottomWidth: 0.5,
          borderBottomColor: palette.light_grey,
        }}
      >
        <Row style={{ height: 50 }}>
          <Col leftCenter maxWidth={50}>
            <Avatar
              first_name={first_name}
              last_name={last_name}
              size={25}
              color={palette.success}
            />
          </Col>
          <Col leftCenter>
            <Text
              style={{
                color: palette.dark,
                fontWeight: "500",
              }}
            >
              {`${first_name} ${last_name}`}
            </Text>
          </Col>
          <Col rightCenter>
            {active && <Icon name="check" size={16} color={palette.dark} />}
          </Col>
        </Row>
      </View>
    </TouchableWithoutFeedback>
  );
};
